import { create } from "zustand";

// Active job progress for the UI (toasts/progress bars). Split out of useJobTracker so org-switch +
// logout can RESET it without an import cycle (orgStore → jobBus is a leaf; useJobTracker → orgStore).
export interface JobUi {
  job_id: string;
  pct: number;
  message?: string;
  status: "running" | "completed" | "failed";
}
interface JobBus {
  jobs: Record<string, JobUi>;
  upsert: (j: JobUi) => void;
  clear: (id: string) => void;
  reset: () => void; // drop ALL jobs — on org switch / logout so one org's/user's jobs never leak
}
export const useJobs = create<JobBus>((set) => ({
  jobs: {},
  upsert: (j) => set((s) => ({ jobs: { ...s.jobs, [j.job_id]: j } })),
  clear: (id) =>
    set((s) => {
      const next = { ...s.jobs };
      delete next[id];
      return { jobs: next };
    }),
  reset: () => set({ jobs: {} }),
}));
